import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {format} from 'ag-common/facades'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import VersetzungsplanIcon from '#components/svg/icons/NavVersetzungsplan'
import StyledText from '#components/a/StyledText'
import {routeKeys} from '#config/routeKeys'

export const VersetzungsplanSerienterminErstellenBenachrichtigung = ({
  userInfo,
  subject,
  from,
  onNotificationClick,
}) => {
  const onClickNotification = () => {
    onNotificationClick(routeKeys.ablaufundtermine)
  }

  const text = i18n.t('notification_text_versetzungsplan_serientermin_erstellt', [
    `${userInfo.lastname}, ${userInfo.firstname}`,
    subject,
    format(new Date(from), 'dd.MM.yy'),
  ])

  return (
    <div
      role="button"
      tabIndex={0}
      className="notification"
      onClick={onClickNotification}
      onKeyPress={onClickNotification}>
      <Avatar profileImage={userInfo.profileImage} />
      <StyledText text={text} modifier="notification" />
      <div className="notification__icon notification__icon--right">
        <VersetzungsplanIcon />
      </div>
    </div>
  )
}

VersetzungsplanSerienterminErstellenBenachrichtigung.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
  onNotificationClick: PropTypes.func.isRequired,
  subject: PropTypes.string,
  from: PropTypes.string,
}

export default UserInfoHOC(VersetzungsplanSerienterminErstellenBenachrichtigung, ['senderId'])
